<header class="header {{cssClass}}">
// header
</header>
